import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import { currencyCode } from 'Helpers/Geo/data';
import Price from 'Components/Utility/Price/Price';
import SelectedTierContext from 'Features/Bundle/context/selected-tier-context';
import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';
import BundleProductTypes from 'Helpers/Product/BundleProductTypes';

export default function TieredBundleSelection({
  bundles,
  bundleType,
  selectTier,
}) {
  const tierFullPrices = [];
  let bundleFullPrice = 0;
  bundles.forEach((tier) => {
    bundleFullPrice += tier.fullPrice[`${currencyCode}`];
    tierFullPrices.push(bundleFullPrice / 100);
  });

  const productTypes = BundleProductTypes(bundles);

  return (
    /* eslint-disable react/style-prop-object */
    <div className="tier-selection-container">
      <Form>
        {bundles.map((tier, tierIndex) =>
          <FormGroup key={tier._id} className="tier-selection">
            <Label check>
              <SelectedTierContext.Consumer>
                {({ selectedTier }) =>
                  <Input
                    aria-label="tier-selection"
                    type="radio"
                    name="tier"
                    checked={selectedTier === tierIndex}
                    onChange={() => selectTier(tierIndex)}
                  />
                }
              </SelectedTierContext.Consumer>
              <div className="selection-label">
                {tier.price[`${currencyCode}`] === 0 && bundleType === 'comic' &&
                  <div>
                    <FormattedMessage
                      id="bundle.tierselection.get_free_comic"
                      defaultMessage="Get tier {tierIndex}: {total, plural, one {# Digital Comic} other {# Digital Comics}}"
                      values={{
                        tierIndex: tierIndex + 1,
                        total: productTypes.tiersTotal[tierIndex].override ? productTypes.tiersTotal[tierIndex].override : productTypes.tiersTotal[tierIndex].all, // eslint-disable-line max-len
                      }}
                    />
                  </div>
                }
                {tier.price[`${currencyCode}`] === 0 && bundleType !== 'comic' &&
                  <div>
                    <FormattedMessage
                      id="bundle.tierselection.get_free_product"
                      defaultMessage="Get tier {tierIndex}: {total, plural, one {# Product} other {# Products}}"
                      values={{
                        tierIndex: tierIndex + 1,
                        total: productTypes.tiersTotal[tierIndex].override ? productTypes.tiersTotal[tierIndex].override : productTypes.tiersTotal[tierIndex].all, // eslint-disable-line max-len
                      }}
                    />
                  </div>
                }
                {tier.price[`${currencyCode}`] !== 0 &&
                  <div>
                    <FormattedMessage
                      id="tiered-bundle-selection.buy-tier"
                      defaultMessage="Buy tier {tierNumber}"
                      values={{
                        tierNumber: tierIndex + 1,
                      }}
                    />
                    :&nbsp;
                    <FormattedMessage
                      id="tiered-bundle-selection.buy-tier-plural-comics"
                      defaultMessage="{total, plural, one {# Product} other {# Products}}"
                      values={{
                        total: productTypes.tiersTotal[tierIndex].override ? productTypes.tiersTotal[tierIndex].override : productTypes.tiersTotal[tierIndex].all, // eslint-disable-line max-len
                      }}
                    />
                  </div>
                }

                <div className="tier-price">
                  <div className="full-price">
                    <SpecialFormattedNumber
                      value={tierFullPrices[`${tierIndex}`]}
                      style="currency"
                    />
                  </div>
                  <Price price={tier.price} />
                </div>
              </div>
            </Label>
          </FormGroup>,
        )}
      </Form>
    </div>
  );
}

TieredBundleSelection.propTypes = {
  bundles: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
  bundleType: PropTypes.string,
  selectTier: PropTypes.func.isRequired,
};

TieredBundleSelection.defaultProps = {
  giveaway: false,
  bundleType: 'standard',
};
